import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';

// CTA reutilizable (fondo navy + subrayado verde) alineado al manual.
const SectionCTA = ({ title, text, to = '/contact', label }) => {
    const { t } = useLanguage();
    return (
    <section className="bg-navy-gradient relative overflow-hidden py-16">
        <div className="absolute -top-24 -right-24 w-72 h-72 bg-salient-green/10 rounded-full blur-3xl"></div>
        <div className="contain relative z-10 text-center">
            <h2 className="text-white font-bold text-3xl md:text-4xl mb-4">{title}</h2>
            <span className="title-underline mx-auto mb-6"></span>
            {text && <p className="text-slate-300 text-lg max-w-2xl mx-auto mb-8">{text}</p>}
            <Link to={to} className="btn btn-accent">{label || t('common.solicitarAsesoria')}</Link>
        </div>
    </section>
    );
};

export default SectionCTA;
